'use client';

export default function PanchangShareButton() {
  const onShare = async () => {
    const shareData = {
      title: 'दैनिक पंचांग | Public App',
      text: 'आज का पंचांग देखें',
      url: window.location.href,
    };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
        return;
      } catch {
        // User cancelled or share failed; fall through to clipboard.
      }
    }

    try {
      await navigator.clipboard.writeText(shareData.url);
    } catch {
      // Clipboard unavailable.
    }
  };

  return (
    <div className='pointer-events-none absolute bottom-8 right-4 z-20'>
      <button
        type='button'
        onClick={onShare}
        className='pointer-events-auto inline-flex items-center gap-2 rounded-full bg-[#772512] px-4 py-2.5 text-[12px] font-semibold text-white shadow-md'
        aria-label='शेयर करें'
      >
        <svg width='16' height='16' viewBox='0 0 24 24' fill='none' aria-hidden>
          <path
            d='M18 8C19.6569 8 21 6.65685 21 5C21 3.34315 19.6569 2 18 2C16.3431 2 15 3.34315 15 5C15 6.65685 16.3431 8 18 8Z'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M6 15C7.65685 15 9 13.6569 9 12C9 10.3431 7.65685 9 6 9C4.34315 9 3 10.3431 3 12C3 13.6569 4.34315 15 6 15Z'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M18 22C19.6569 22 21 20.6569 21 19C21 17.3431 19.6569 16 18 16C16.3431 16 15 17.3431 15 19C15 20.6569 16.3431 22 18 22Z'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M8.59 13.51L15.42 17.49M15.41 6.51001L8.59 10.49'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
        शेयर करें
      </button>
    </div>
  );
}
